import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CommonUtilitiesService } from '../common-utilities.service';

@Component({
  selector: 'app-payment-view-urlok',
  templateUrl: './payment-view-urlok.component.html',
  styleUrls: ['./payment-view-urlok.component.scss']
})
export class PaymentViewUrlokComponent implements OnInit {

  msisdn = "";
  rechargeAmount = "";
  cCard = "";
  authNumber = "";
  txNumber = "";
  txDate = "";

  constructor(public LANG: CommonUtilitiesService, private route: ActivatedRoute) { }

  ngOnInit() {

    let _self = this;
    this.route.params.subscribe(params => this.setErrorParams(params));
  }

  setErrorParams(params) {

    this.msisdn = params.msisdn;
    this.rechargeAmount = params.rechargeAmount;
    this.cCard = params.cCard;
    this.authNumber = params.authNumber;
    this.txNumber = params.txNumber;
    this.txDate = params.txDate;
  }


}
